import { clsx } from "clsx";

import {
	type AxisCell,
	PX_PER_DAY,
	type TimeScale,
} from "../../utils/scale.ts";
import type { TimelineDomain } from "../../utils/timeline.ts";

export function GanttAxis({
	domain,
	scale,
	months,
	cells,
	todayAt,
}: {
	domain: TimelineDomain;
	scale: TimeScale;
	months: AxisCell[];
	cells: AxisCell[];
	todayAt: number | null;
}) {
	const px = PX_PER_DAY[scale];
	return (
		<div
			className="schedule-gantt__axis"
			style={{ width: `${domain.totalDays * px}px` }}
		>
			<div className="schedule-gantt__months">
				{months.map((month) => (
					<span
						key={month.key}
						className="schedule-gantt__month"
						style={{ width: `${month.days * px}px` }}
					>
						{month.label}
					</span>
				))}
			</div>
			<div className="schedule-gantt__cells">
				{cells.map((cell) => (
					<span
						key={cell.key}
						className={clsx(
							"schedule-gantt__cell",
							cell.weekend && "is-weekend",
							cell.today && "is-today",
						)}
						style={{ width: `${cell.days * px}px` }}
					>
						<span>{cell.label}</span>
						{cell.sublabel && (
							<span className="schedule-gantt__cell-sub">{cell.sublabel}</span>
						)}
					</span>
				))}
				{todayAt !== null && (
					<span
						className="schedule-gantt__today-badge"
						style={{ left: `${(todayAt + 0.5) * px}px` }}
					>
						HOJE
					</span>
				)}
			</div>
		</div>
	);
}
